import update from 'immutability-helper'
import {
  retrieveUser, storeUser, retrievePersonal, storePersonal
} from '../../lib/dexie'

export const INIT_SETTING = 'INIT_SETTING'
export const SAVE_SETTING = 'SAVE_SETTING'
export const SET_SETTING = 'SET_SETTING'

export const initSetting = () => async (dispatch, getState) => {
  dispatch(setSetting({
    user: await retrieveUser(),
    personal: await retrievePersonal()
  }))
}

export const saveSetting = saving => async (dispatch, getState) => {
  let { setting } = getState()

  if ('user' in saving) {
    setting = update(setting, { user: { $set: saving.user } })
    storeUser(saving.user)
  }

  if ('personal' in saving) {
    setting = update(setting, { personal: { $set: saving.personal } })
    storePersonal(saving.personal)
  }

  dispatch(setSetting(setting))
}

export const setSetting = setting => {
  return { type: SET_SETTING, setting }
}
